export const legal = {
  termsTitle: 'გამოყენების პირობები',
  privacyTitle: 'კონფიდენციალურობის პოლიტიკა',
};
